export const minViewportWidth = 325;

// Breakpoints
// https://bitbucket.hotterpads.com/projects/RP/repos/multibrand-ui/browse/src/scss/_breakpoints.scss
export const SCREEN_SM_MIN = 480;
export const SCREEN_LG_MIN = 992;
export const breakpointMD = 1024;
